export function detectLanguage() {
  if (typeof window === "undefined") return "it";

  const path = window.location.pathname.toLowerCase();
  const params = new URLSearchParams(window.location.search);
  const langParam = (params.get("lang") || params.get("locale") || "").toLowerCase();

  if (path === "/en" || path.startsWith("/en/") || langParam.startsWith("en")) {
    return "en";
  }

  return "it";
}

export const locales = {
  it: "it-IT",
  en: "en-US",
};

export const translations = {
  it: {
    common: {
      yes: "SI",
      no: "NO",
      select: "Seleziona",
      male: "Maschio",
      female: "Femmina",
      requiredStep1: "Compila tutti i campi obbligatori dello step 1 prima di calcolare il premio.",
      requiredB2BStep1: "Compila tutti i campi obbligatori: data, location e budget.",
      requiredFinalize: "Compila tutti i campi obbligatori e conferma le dichiarazioni prima di inviare la richiesta.",
      requiredB2BFinalize: "Compila tutti i campi obbligatori prima di inviare la richiesta.",
      minDate: "La prima data selezionabile è",
      quoteUnavailable: "Combinazione non conveniente. Modifica budget o fascia oraria per ottenere una quotazione.",
      b2bQuoteUnavailable: "Combinazione non conveniente. Alza la soglia o riduci le ore per ottenere una quotazione.",
      connectionError: "Errore di connessione.",
      emailSummaryError: "Premio calcolato, ma non è stato possibile inviare la mail di riepilogo.",
      sendError: "Errore durante l'invio della mail.",
      calculateFirst: "Calcola prima il premio.",
      calculateFirstB2B: "Calcola prima il prezzo.",
      sentB2B: "Richiesta inviata. Verrai ricontattato dall'agenzia.",
      pdfNotReady: "Libreria PDF non ancora pronta. Riprova tra qualche secondo.",
      logoMissing: "Logo obbligatorio non disponibile: impossibile generare il PDF.",
    },
    b2c: {
      heroBefore: "Quanto costa",
      heroHighlight: "proteggere",
      heroAfter: "il tuo matrimonio dalla pioggia?",
      eventDate: "Data dell'evento",
      location: "Location",
      locationPlaceholder: "Nome o indirizzo esatto",
      budget: "Budget da assicurare",
      amountPlaceholder: "es.: 20000",
      budgetTooltip: "Somma i costi: fiori, tensostrutture, luci, catering, location ecc...",
      budgetTooltipSecond: "Inserisci tutto o una parte delle spese sostenute",
      indemnity: "Indennizzo",
      rainThreshold: "Quantità minima di pioggia per il rimborso",
      rainTooltip: "Per far scattare l’indennizzo si devono cumulare almeno questi millimetri nelle ore coperte dalla polizza",
      weddingTime: "Quando ti sposi?",
      weddingTimeTooltip: "Orario in cui la polizza è attiva e viene rilevata la pioggia caduta",
      morning: "Mattina",
      afternoon: "Pomeriggio",
      privacySeen: "Ho preso visione dell'informativa privacy",
      marketing: "Sì, desidero ricevere consigli, novità e offerte da Wedly",
      personalization: "Ok alla personalizzazione: voglio contenuti davvero adatti a me!",
      calculateLoading: "CALCOLO IN CORSO...",
      calculate: "CALCOLA IL PREMIO",
      estimatedPremium: "Premio stimato",
      proceed: "PROCEDI E BLOCCA IL PREZZO",
      pdfLoading: "GENERAZIONE PDF...",
      downloadPdf: "SCARICA PDF",
      firstName: "Nome",
      lastName: "Cognome",
      phone: "Telefono",
      phoneCountryAria: "Nazione e prefisso telefonico",
      fiscalCode: "Codice Fiscale",
      gender: "Genere",
      birthDate: "Data di nascita",
      birthPlace: "Luogo di nascita",
      birthPlacePlaceholder: "Inserisci nazione",
      residenceAddress: "Indirizzo di residenza",
      residencePlaceholder: "Via, numero civico, città",
      capPlaceholder: "Es. 20121",
      rainConfirmQuestion: "Confermi che intendi proteggerti in caso di pioggia che comprometta l'organizzazione del tuo evento privato all'aperto?",
      confirmIntent: "Accetto e confermo la mia intenzione.",
      confirmTruth: "Certifico la correttezza e la veridicità dei dati forniti.",
      privacyAcceptBefore: "Accetto e dichiaro di aver preso visione",
      privacyLink: "dell'informativa della privacy",
      submitLoading: "INVIO IN CORSO...",
      submit: "INVIA RICHIESTA IN AGENZIA",
      thankTitle: "Richiesta inviata correttamente 🚀",
      thankIntro: "Abbiamo ricevuto i dati del tuo matrimonio e la richiesta per il preventivo ufficiale.",
      thankNextSteps: "Nei prossimi giorni ti scriveremo all’indirizzo email che hai indicato con tutti i dettagli per verificare e attivare la polizza.",
      thankNoAction: "Per ora non devi fare altro.",
      thankContact: "Se ci serve qualche informazione in più, ti contattiamo noi.",
      doubtsQuestion: "Hai dubbi o vuoi parlarci?",
      doubts: "Scrivici a",
      day: "Il giorno",
      venue: "Nella location",
      timeRange: "Nel seguente orario",
      activationThreshold: "Soglia di attivazione",
      insuredBudget: "Budget assicurato",
      automaticIndemnity: "Indennizzo automatico",
    },
    b2b: {
      heroBefore: "Quanto costa",
      heroHighlight: "proteggere",
      heroAfter: "il matrimonio dei tuoi sposi dalla pioggia?",
      eventDate: "Data dell’evento",
      location: "Location",
      locationPlaceholder: "Inserisci la location",
      budget: "Budget da assicurare",
      indemnity: "Indennizzo",
      rainThreshold: "Quantità minima di pioggia per il rimborso",
      light: "Leggera",
      lightDesc: "Qualche goccia",
      moderate: "Moderata",
      moderateDesc: "Pioggia continua",
      heavy: "Forte",
      heavyDesc: "Temporali intensi",
      coverageStart: "Inizio copertura",
      coverageEnd: "Fine copertura",
      maxHours: "Massimo 9 ore, massimo fino alle 00:00",
      calculateLoading: "Calcolo in corso...",
      calculate: "Calcola il premio",
      estimatedPremium: "Premio stimato",
      proceed: "Procedi e blocca il prezzo",
      personalData: "Dati anagrafici",
      supplierCode: "Codice fornitore",
      weddingOf: "Matrimonio di",
      weddingOfPlaceholder: "Nome degli sposi",
      firstName: "Nome",
      lastName: "Cognome",
      phone: "Telefono",
      fiscalCode: "Codice Fiscale",
      gender: "Genere",
      birthDate: "Data di nascita",
      birthPlace: "Luogo di nascita",
      birthPlacePlaceholder: "Inserisci nazione",
      residence: "Residenza",
      fullAddress: "Indirizzo completo",
      residencePlaceholder: "Via, numero civico, città",
      capPlaceholder: "Es. 20121",
      privacyBefore: "Accetto l’",
      privacyLink: "informativa sulla privacy",
      rainConfirm: "Confermi che intendi proteggerti in caso di pioggia che comprometta l'organizzazione del tuo evento privato all'aperto?",
      back: "« Torna indietro",
      submitLoading: "Invio...",
      submit: "Invia richiesta",
      downloadPdf: "Scarica PDF",
    },
  },
  en: {
    common: {
      yes: "YES",
      no: "NO",
      select: "Select",
      male: "Male",
      female: "Female",
      requiredStep1: "Please complete all required fields in step 1 before calculating the premium.",
      requiredB2BStep1: "Please complete all required fields: date, location and budget.",
      requiredFinalize: "Please complete all required fields and confirm the declarations before submitting the request.",
      requiredB2BFinalize: "Please complete all required fields before submitting the request.",
      minDate: "The first selectable date is",
      quoteUnavailable: "This combination is not available. Change the budget or time slot to get a quote.",
      b2bQuoteUnavailable: "This combination is not available. Increase the threshold or reduce the covered hours to get a quote.",
      connectionError: "Connection error.",
      emailSummaryError: "Premium calculated, but the summary email could not be sent.",
      sendError: "Error while sending the email.",
      calculateFirst: "Calculate the premium first.",
      calculateFirstB2B: "Calculate the price first.",
      sentB2B: "Request sent. The agency will contact you.",
      pdfNotReady: "The PDF library is not ready yet. Please try again in a few seconds.",
      logoMissing: "Required logo unavailable: unable to generate the PDF.",
    },
    b2c: {
      heroBefore: "How much does it cost to",
      heroHighlight: "protect",
      heroAfter: "your wedding from rain?",
      eventDate: "Event date",
      location: "Location",
      locationPlaceholder: "Exact name or address",
      budget: "Budget to insure",
      amountPlaceholder: "e.g.: 20000",
      budgetTooltip: "Add up the costs: flowers, marquees, lights, catering, venue, etc...",
      budgetTooltipSecond: "Enter all or part of the expenses incurred",
      indemnity: "Payout",
      rainThreshold: "Minimum rainfall amount for reimbursement",
      rainTooltip: "To trigger the payout, at least this many millimetres must accumulate during the hours covered by the policy",
      weddingTime: "When are you getting married?",
      weddingTimeTooltip: "Time window when the policy is active and rainfall is measured",
      morning: "Morning",
      afternoon: "Afternoon",
      privacySeen: "I have read the privacy notice",
      marketing: "Yes, I would like to receive tips, news and offers from Wedly",
      personalization: "Yes to personalization: I want content that is truly relevant to me!",
      calculateLoading: "CALCULATING...",
      calculate: "CALCULATE PREMIUM",
      estimatedPremium: "Estimated premium",
      proceed: "CONTINUE AND LOCK THE PRICE",
      pdfLoading: "GENERATING PDF...",
      downloadPdf: "DOWNLOAD PDF",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      phoneCountryAria: "Country and phone prefix",
      fiscalCode: "Tax code",
      gender: "Gender",
      birthDate: "Date of birth",
      birthPlace: "Place of birth",
      birthPlacePlaceholder: "Enter country",
      residenceAddress: "Residential address",
      residencePlaceholder: "Street, number, city",
      capPlaceholder: "E.g. 20121",
      rainConfirmQuestion: "Do you confirm that you intend to protect yourself in case rain affects the organization of your private outdoor event?",
      confirmIntent: "I accept and confirm my intention.",
      confirmTruth: "I certify that the data provided is correct and truthful.",
      privacyAcceptBefore: "I accept and declare that I have read",
      privacyLink: "the privacy notice",
      submitLoading: "SENDING...",
      submit: "SEND REQUEST TO THE AGENCY",
      thankTitle: "Request sent successfully 🚀",
      thankIntro: "We have received your wedding details and your request for the official quote.",
      thankNextSteps: "Over the next few days we will write to the email address you provided with all the details to verify and activate the policy.",
      thankNoAction: "You do not need to do anything else for now.",
      thankContact: "If we need any additional information, we will contact you.",
      doubtsQuestion: "Questions or want to talk to us?",
      doubts: "Email us at",
      day: "Date",
      venue: "Venue",
      timeRange: "Time window",
      activationThreshold: "Activation threshold",
      insuredBudget: "Insured budget",
      automaticIndemnity: "Automatic payout",
    },
    b2b: {
      heroBefore: "How much does it cost to",
      heroHighlight: "protect",
      heroAfter: "your couple’s wedding from rain?",
      eventDate: "Event date",
      location: "Location",
      locationPlaceholder: "Enter the location",
      budget: "Budget to insure",
      indemnity: "Payout",
      rainThreshold: "Minimum rainfall amount for reimbursement",
      light: "Light",
      lightDesc: "A few drops",
      moderate: "Moderate",
      moderateDesc: "Continuous rain",
      heavy: "Heavy",
      heavyDesc: "Intense storms",
      coverageStart: "Coverage start",
      coverageEnd: "Coverage end",
      maxHours: "Maximum 9 hours, until 00:00 at the latest",
      calculateLoading: "Calculating...",
      calculate: "Calculate premium",
      estimatedPremium: "Estimated premium",
      proceed: "Continue and lock the price",
      personalData: "Personal details",
      supplierCode: "Supplier code",
      weddingOf: "Wedding of",
      weddingOfPlaceholder: "Couple’s names",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      fiscalCode: "Tax code",
      gender: "Gender",
      birthDate: "Date of birth",
      birthPlace: "Place of birth",
      birthPlacePlaceholder: "Enter country",
      residence: "Residence",
      fullAddress: "Full address",
      residencePlaceholder: "Street, number, city",
      capPlaceholder: "E.g. 20121",
      privacyBefore: "I accept the ",
      privacyLink: "privacy notice",
      rainConfirm: "Do you confirm that you intend to protect yourself in case rain affects the organization of your private outdoor event?",
      back: "« Back",
      submitLoading: "Sending...",
      submit: "Send request",
      downloadPdf: "Download PDF",
    },
  },
};

export function getTranslations(language = detectLanguage()) {
  return translations[language] || translations.it;
}
